<template>
    <img :src="`${$apiImgWeb}/images/web${src}`" :alt="alt" :class="className" loading="lazy"/>
  </template>
  
  <script>
  export default {
    props: {
      src: String,
      alt: String,
      className: String
    }
  };
  </script>